export var ManifestType;
(function (ManifestType) {
    ManifestType["EMPTY"] = "";
    ManifestType["MANUSCRIPT"] = "manuscript";
    ManifestType["MONOGRAPH"] = "monograph";
})(ManifestType || (ManifestType = {}));
//# sourceMappingURL=ManifestType.js.map